import { render } from "./AccountsManagement.html?vue&type=template&id=126c2a0e&scoped=true"
import script from "./AccountsManagement.js?vue&type=script&lang=js"
export * from "./AccountsManagement.js?vue&type=script&lang=js"

import "./AccountsManagement.css?vue&type=style&index=0&id=126c2a0e&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/ShipTech/st-web-petro-network-admin-portal/src/ST.PetroNetworkAdmin.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-126c2a0e"]])

export default __exports__